import { OwaDate } from 'owa-datetime';
import differenceInDays from 'owa-datetime/lib/owaDate/differenceInDays';
import now from 'owa-datetime/lib/userDate/now';
import startOfDay from 'owa-datetime/lib/owaDate/startOfDay';

export default function(dueDate: OwaDate, referenceDate: OwaDate = now()): boolean {
    if (differenceInDays(startOfDay(referenceDate), startOfDay(dueDate)) > 0) {
        return true;
    }

    return false;
}
